import type { MessageId, OrchestrationMessage, TurnId } from "@afar-research/contracts";

export function isSyntheticCheckpointAssistantMessageId(
  messageId: MessageId,
  turnId: TurnId,
): boolean {
  return messageId === `assistant:${turnId}`;
}

export function resolveCheckpointAssistantMessageId(input: {
  readonly reportedMessageId: MessageId | null;
  readonly turnId: TurnId;
  readonly messages: ReadonlyArray<OrchestrationMessage>;
  readonly existingMessageId?: MessageId | null;
}): MessageId | null {
  if (
    input.reportedMessageId !== null &&
    !isSyntheticCheckpointAssistantMessageId(input.reportedMessageId, input.turnId)
  ) {
    return input.reportedMessageId;
  }
  const latestTurnAssistant = input.messages
    .toReversed()
    .find((message) => message.role === "assistant" && message.turnId === input.turnId);
  return latestTurnAssistant?.id ?? input.existingMessageId ?? input.reportedMessageId;
}
